/* Keep the live Judge.me summary linked to this homepage's full review section. */
(() => {
  const summarySelector = '.jdgm-all-reviews-text';
  const destination = '#customer-reviews';
  if (!document.querySelector(destination)) return;

  const connect = () => {
    document.querySelectorAll(`${summarySelector} a`).forEach((link) => {
      if (link.getAttribute('href') !== destination) link.setAttribute('href', destination);
    });
  };
  connect();
  // Judge.me can replace its markup after loading or updating the rating.
  const observer = new MutationObserver(connect);
  const summary = document.querySelector(summarySelector);
  observer.observe(summary?.parentElement || document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });
  // Route the summary to the on-page reviews instead of the app modal.
  window.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest(`${summarySelector} a`)) {
      connect();
      event.preventDefault();
      event.stopImmediatePropagation();
      const reviews = document.querySelector(destination);
      history.pushState(null, '', destination);
      reviews.setAttribute('tabindex', '-1');
      reviews.focus({ preventScroll: true });
      reviews.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start'
      });
    }
  }, true);
})();
